import React from 'react'

import * as EmptyState from '@modules/Dashboard/components/EmptyState/EmptyState'

export const OrdersEmptyState = () => {
  return (
    <EmptyState.Root
      title="No orders found"
      subtitle="Adjust your filters or try different search term."
    />
  )
}
